import { render, staticRenderFns } from "./gongjiao.vue?vue&type=template&id=70c82418&scoped=true&"
import script from "./gongjiao.vue?vue&type=script&lang=js&"
export * from "./gongjiao.vue?vue&type=script&lang=js&"
import style0 from "./gongjiao.vue?vue&type=style&index=0&id=70c82418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c82418",
  null
  
)

export default component.exports